<header
  class="hero-wrapper"
  [attr.aria-label]="ariaLabel()"
  [class.hero-wrapper--border-radius]="hasEssentRebranding() && borderRadius()"
  [class.hero-wrapper--has-image]="!!backgroundImageStyle().backgroundImage"
  [ngStyle]="backgroundImageStyle()"
>
  <div
    class="hero-wrapper__container"
    [ngClass]="hasEssentRebranding() ? 'container-md' : 'container'"
  >
    <div
      class="hero-wrapper__row row py-4"
      [ngClass]="{
        'pb-md-8 pt-md-4 pb-lg-10 pt-lg-6': hasEssentRebranding() && large(),
        'pt-0': hasEssentRebranding() && hasBreadcrumbs() && large(),
      }"
    >
      <ng-content />
    </div>
  </div>
</header>
